import * as THREE from 'three'
import { randFloatSpread } from '@/utils/random'

/* eslint-disable */
const defaultSettings = {
  width: 200,       // width of area (x-axis)
  length: 200,      // length of area (z-axis)
  speed: 50,        // wind speed
  vertices: {
    count: 5,       // vertex count
    width: 0.2,     // vertex width
    length: 20,     // vertex length
    rotation: 0,    // vertex rotation (x-axis)
    color: 0xf0f8ff // vertex color
  }
}
/* eslint-enable */

/**
 * Create a wind Mesh
 * @param {Number} length length of vertex
 * @param {Number} width width of vertex
 * @param {Hex} color vertex color
 */
function createVertex (width, length, color) {
  const center = length * 1 / 3

  const points = [
    new THREE.Vector2(0, 0),
    new THREE.Vector2(center, width / 2),
    new THREE.Vector2(length, 0),
    new THREE.Vector2(center, -width / 2)
  ]

  const shape = new THREE.Shape(points)
  const geometry = new THREE.ShapeBufferGeometry(shape)
  const material = new THREE.MeshBasicMaterial({ color, side: THREE.DoubleSide })

  return new THREE.Mesh(geometry, material)
}

/**
 * Generate a random position within the plane defined by length and width.
 * @param {Number} width plane width (x-axis)
 * @param {Number} length plane length (z-axis)
 */
function randomPosition (width, length) {
  return new THREE.Vector3(
    randFloatSpread(width),
    0,
    randFloatSpread(length)
  )
}

export default class Wind extends THREE.Group {
  name = 'Wind'

  constructor (settings) {
    super()

    this.debug = process.env.NODE_ENV !== 'production'
    this.settings = Object.assign({}, defaultSettings, settings)

    this.createVertices()
    this.debug && this.drawPlane()
  }

  createVertices () {
    const { vertices, width, length } = this.settings
    const vertex = createVertex(vertices.width, vertices.length, vertices.color)
    vertex.rotateX(vertices.rotation)

    for (let i = 0; i < vertices.count; i++) {
      const mesh = vertex.clone()
      const position = randomPosition(width, length)
      mesh.position.copy(position)
      this.add(mesh)
    }
  }

  drawPlane () {
    const { width, length } = this.settings

    const geometry = new THREE.PlaneGeometry(width, length)
    const material = new THREE.MeshBasicMaterial({ color: 0xffff00, wireframe: true })
    const plane = new THREE.Mesh(geometry, material)

    plane.rotateX(-Math.PI / 2)
    plane.name = 'debug'

    this.add(plane)
  }

  update (delta) {
    const { width, length, speed } = this.settings

    this.children.forEach(mesh => {
      if (mesh.name === 'debug') return

      if (mesh.position.x < -width / 2) {
        mesh.position.x = width / 2
        mesh.position.z = randFloatSpread(length)
      }

      mesh.position.x -= delta * speed
    })
  }
}
